var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97.82,
    height: 85.563,
    viewBox: "0 0 97.82 85.563",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2863",
    "data-name": "Group 2863",
    transform: "translate(-659 -420.099)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2861",
    "data-name": "Group 2861",
    transform: "translate(659 420.099)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-form-1040521",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11466",
    "data-name": "Path 11466",
    d: "M214.92,76.07h12.512v1.947H214.92Z",
    transform: "translate(-199.22 -69.126)",
    fill: "#eeac79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11467",
    "data-name": "Path 11467",
    d: "M214.92,137.87h43.8v1.947h-43.8Z",
    transform: "translate(-199.22 -120.183)",
    fill: "#eeac79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11468",
    "data-name": "Path 11468",
    d: "M214.92,193.89h43.8v1.947h-43.8Z",
    transform: "translate(-199.22 -166.465)",
    fill: "#eeac79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11469",
    "data-name": "Path 11469",
    d: "M214.92,250.84h37.256v1.947H214.92Z",
    transform: "translate(-199.22 -213.516)",
    fill: "#eeac79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11470",
    "data-name": "Path 11470",
    d: "M214.92,305.93h28.652v1.947H214.92Z",
    transform: "translate(-199.22 -259.03)",
    fill: "#eeac79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11471",
    "data-name": "Path 11471",
    d: "M214.92,365.64h22.226v1.947H214.92Z",
    transform: "translate(-199.22 -308.36)",
    fill: "#eeac79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11472",
    "data-name": "Path 11472",
    d: "M214.92,424.92h30.462v1.947H214.92Z",
    transform: "translate(-199.22 -357.336)",
    fill: "#eeac79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11478",
    "data-name": "Path 11478",
    d: "M400.1,81.672h11.614v7.069H400.1Z",
    transform: "translate(-352.211 -73.754)",
    fill: "#eeac79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11479",
    "data-name": "Path 11479",
    d: "M428.971,411.547a3.992,3.992,0,1,1-3.992-3.992,3.992,3.992,0,0,1,3.992,3.992",
    transform: "translate(-369.466 -342.989)",
    fill: "#eeac79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11480",
    "data-name": "Path 11480",
    d: "M297.34,76.07h4.3v1.947h-4.3Z",
    transform: "translate(-267.314 -69.126)",
    fill: "#eeac79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11481",
    "data-name": "Path 11481",
    d: "M192.536,64.518V36.12H131.608v6.389h-7v79.175h53.626v-5.52h14.307V85.753h-3.893v26.516H135.5V40.014h53.141v24.5Zm-18.2,51.646v1.626H128.5V46.4h3.111v69.76Z",
    transform: "translate(-124.603 -36.12)",
    fill: "#eeac79"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2860",
    "data-name": "Group 2860",
    transform: "translate(48.408 26.459)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_559",
    "data-name": "Ellipse 559",
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    transform: "translate(-0.255 -0.292)",
    fill: "#00ac94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11482",
    "data-name": "Path 11482",
    d: "M-10850.465-14095.386c-.039,0-.078,0-.117,0a1.662,1.662,0,0,1-1.223-.677l-4.243-5.813a1.658,1.658,0,0,1,.362-2.316,1.658,1.658,0,0,1,2.316.362l3.085,4.226,11.009-11.323a1.659,1.659,0,0,1,2.346-.033,1.659,1.659,0,0,1,.031,2.345l-12.378,12.732A1.661,1.661,0,0,1-10850.465-14095.386Z",
    transform: "translate(10862.334 14119.391)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2862",
    "data-name": "Group 2862",
    transform: "translate(732.353 433.864)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11482-2",
    "data-name": "Path 11482",
    d: "M2.323,11.989A2.323,2.323,0,0,1,.083,9.054L2.1,1.708A2.321,2.321,0,1,1,6.572,2.935L4.56,10.28A2.322,2.322,0,0,1,2.323,11.989Z",
    transform: "translate(2.9 0) rotate(14)",
    fill: "#00ac94",
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11483",
    "data-name": "Path 11483",
    d: "M2.323,11.989A2.323,2.323,0,0,1,.083,9.054L2.1,1.708A2.321,2.321,0,0,1,6.573,2.935L4.56,10.28A2.322,2.322,0,0,1,2.323,11.989Z",
    transform: "matrix(0.616, 0.788, -0.788, 0.616, 20.369, 9.827)",
    fill: "#00ac94",
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11484",
    "data-name": "Path 11484",
    d: "M2.323,11.988A2.323,2.323,0,0,1,.083,9.053L2.1,1.708A2.321,2.321,0,1,1,6.572,2.935L4.56,10.28A2.322,2.322,0,0,1,2.323,11.988Z",
    transform: "translate(23.686 29.437) rotate(94)",
    fill: "#00ac94",
    opacity: 0.53
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessList);
export default __webpack_public_path__ + "static/media/SuccessList.2f7a026a367c1ea286c41be8990f40f6.svg";
export { ForwardRef as ReactComponent };